import { useState } from "react";
import { Download } from "lucide-react";
import { toPng } from "html-to-image";
import { toast } from "sonner";

// Injects a watermark footer into the target node, captures, and removes it.
// This makes every shared PNG a tiny ad for tools.guango.co (viral growth).
const injectWatermark = (node, color) => {
  const wm = document.createElement("div");
  wm.setAttribute("data-watermark", "true");
  wm.style.cssText = [
    "margin-top:16px",
    "padding:10px 14px",
    "border:3px solid #1a1a1a",
    "border-radius:12px",
    "background:#1a1a1a",
    "color:#F7F5F0",
    "font-family:'IBM Plex Mono', ui-monospace, monospace",
    "font-size:12px",
    "font-weight:700",
    "letter-spacing:0.08em",
    "text-transform:uppercase",
    "display:flex",
    "align-items:center",
    "justify-content:space-between",
    "gap:12px",
    "box-shadow:4px 4px 0 0 #1a1a1a",
  ].join(";");
  wm.innerHTML = `
    <span style="display:inline-flex;align-items:center;gap:8px">
      <span style="display:inline-block;width:14px;height:14px;background:${color};border:2px solid #F7F5F0;border-radius:3px"></span>
      hecho con tools.guango.co
    </span>
    <span style="opacity:0.7">crea el tuyo →</span>
  `;
  node.appendChild(wm);
  return () => {
    if (wm.parentNode === node) node.removeChild(wm);
  };
};

export const DownloadImageButton = ({ targetRef, fileName = "guango-reto.png", color = "#22C55E", testId = "download-img-btn" }) => {
  const [busy, setBusy] = useState(false);

  const download = async () => {
    if (!targetRef?.current) return;
    setBusy(true);
    const removeWatermark = injectWatermark(targetRef.current, color);
    try {
      const dataUrl = await toPng(targetRef.current, {
        backgroundColor: "#F7F5F0",
        pixelRatio: 2,
        cacheBust: true,
        filter: (node) => {
          // skip elements explicitly marked to be excluded from the snapshot
          if (node?.dataset?.excludeFromImage === "true") return false;
          return true;
        },
      });
      const link = document.createElement("a");
      link.download = fileName;
      link.href = dataUrl;
      link.click();
      toast.success("Imagen descargada");
    } catch (e) {
      console.error(e);
      toast.error("No se pudo generar la imagen.");
    } finally {
      removeWatermark();
      setBusy(false);
    }
  };

  return (
    <button
      data-testid={testId}
      onClick={download}
      disabled={busy}
      className="press inline-flex items-center gap-2 border-4 border-[#1a1a1a] rounded-xl px-5 py-3 font-mono text-sm uppercase tracking-wider font-bold shadow-hard-sm disabled:opacity-50 bg-white"
      style={{ background: busy ? "#e5e1d5" : "white" }}
    >
      <Download className={`w-4 h-4 ${busy ? "animate-bounce" : ""}`} strokeWidth={3} />
      {busy ? "generando..." : "imagen png"}
    </button>
  );
};

export default DownloadImageButton;
